/**
 * One screen failing must never blank the whole Console (found by the
 * full-Console check, 2026-10-09: an unexpected connector payload threw during
 * render and the entire app went white). The boundary says, in words, that this
 * screen could not be shown; navigation and every other screen keep working.
 */
import { Component, type ReactNode } from 'react';

export class ScreenBoundary extends Component<
  { children: ReactNode; name: string },
  { failed: boolean }
> {
  override state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  override componentDidUpdate(prev: { name: string }) {
    if (prev.name !== this.props.name && this.state.failed) this.setState({ failed: false });
  }
  override render() {
    if (this.state.failed) {
      return (
        <div className="banner" role="alert">
          <strong>This screen could not be shown.</strong> The data it received was not in the shape
          it expects. Nothing on it is being reported as healthy; other sections still work.
        </div>
      );
    }
    return this.props.children;
  }
}
